/* eslint-disable */

import React, {useState} from "react";
import moment from "moment";
import APIClient from "../client";
import Modal from "react-bootstrap/Modal";
import { Button, ButtonGroup, Spinner } from "react-bootstrap";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
import LeafletMap from "../../shared/components/LeafletMap";
import Wkt from "wicket/wicket-leaflet";

import cropr from "../../shared/utils/cropr";
import gettext from "../../shared/utils/gettext";
import { Model, interpolate, OpenLayers, Cropr } from "../../shared/utils/legacy";

const { SearchBar } = Search;

class DatasetDetailsModal extends React.Component {
  state = {
    loading: true,
    key: "general",
  };

  componentDidMount() {
    this.loadDetails();
    if (this.props.tab) {
      this.setState({ key: this.props.tab });
    }
  }

  async loadDetails() {
    let path = "/api/data/datasets/" + this.props.dataset.uuid + "/";
    let data = await APIClient.get(path, null, cropr.cloudfarm_oauth_token);
    this.setState({
      loading: false,
      data: data,
    });
  }

  render() {
    return (
      <Modal show={true} onHide={this.props.handleHide} dialogClassName="modal-xl">
        <Modal.Header closeButton>
          <Modal.Title>{gettext("Dataset details")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {this.state.loading ? (
            <div className="mx-auto" style={{ width: "300px" }}>
              <Spinner animation="border" role="status">
                <span className="sr-only">Loading...</span>
              </Spinner>
            </div>
          ) : (
            <Tabs activeKey={this.state.key} onSelect={(key) => this.setState({ key })}>
              <Tab eventKey="general" title={gettext("General")}>
                <DatasetGeneralDetails data={this.state.data} />
              </Tab>
              {this.state.data.extra_info ? (
                <Tab eventKey="task" title={gettext("Task")}>
                  <DatasetDetailsContent cols={cropr.getCloudFarmExtraInfo(this.state.data)} />
                </Tab>
              ) : null}
              <Tab eventKey="statistics" title={gettext("Statistics")}>
                <DatasetStatistics data={this.state.data} />
              </Tab>
              {this.state.key === "geometry" ? (
                <Tab eventKey="geometry" title={gettext("Geometry")}>
                  <DatasetGeometry data={this.state.data} handleReload={this.props.handleReload} />
                </Tab>
              ) : (
                <Tab eventKey="geometry" title={gettext("Geometry")}></Tab>
              )}
            </Tabs>
          )}
        </Modal.Body>
      </Modal>
    );
  }
}

const DatasetGeneralDetails = (props) => {
  const dataset = props.data,
    cols = [];

  const [processedRecords, useProcessedRecords] = useState(null);
  let downloadFile = function (e) {
    e.preventDefault();
    const ds_id = dataset.uuid;
    APIClient.get(
      `/api/data/datasets/${ds_id}/download/`,
      null,
      cropr.cloudfarm_oauth_token
    ).then((res) => window.open(res, "_blank"));
  };

  let processDs = async function (e) {
    e.preventDefault();
    const ds_id = dataset.uuid;
    const response = await fetch(`/apps/cloudfarm/process_dataset/${ds_id}/`);
    const processed_records = await response.json();
    useProcessedRecords(processed_records)
    let notificationType =  "info";
    let notificationMsg =  gettext("No records created. ");
    if (dataset.data_set_rois.length === 0){
      notificationMsg += gettext("First create fields please.")
    }
    if (Object.keys(processed_records).length > 0){
      notificationType = "success";
      notificationMsg = interpolate(gettext("%s record(s) were created or updated."), [Object.keys(processed_records).length]);
    }
    cropr.notify(notificationType, notificationMsg)
  };
  const genCol = [[gettext("ID"), dataset.uuid]];
  if (dataset.name) {
    genCol.push([gettext("Name"), dataset.name]);
  }
  genCol.push([gettext("Data type"), dataset.data_type]);
  genCol.push([gettext("Start"), moment(dataset.recording_datetime).format(" LLLL")]);
  if (dataset.stopped_recording_datetime) {
    genCol.push([
      gettext("Duration"),
      moment
        .duration(
          moment(dataset.stopped_recording_datetime).diff(moment(dataset.recording_datetime))
        )
        .humanize(),
    ]);
  }
  if (dataset.source) {
    genCol.push([gettext("Source"), SOURCE_MAPPING[dataset.source]]);
  }
  if (dataset.data_format && dataset.data_format !== " n") {
    genCol.push([gettext("Data format"), DATA_FORMAT_MAPPING[dataset.data_format]]);
  }
  if (dataset.file) {
    genCol.push([
      gettext("File"),
      <a onClick={downloadFile} href="#">
        {dataset.file}
      </a>,
    ]);
  }
  genCol.push([gettext("Created"), moment(dataset.created).format(" LLLL")]);
  if (dataset.extra_info){
    genCol.push([
      gettext("Automatic recording"),
      <a onClick={processDs} href="#">
        {gettext("(re)process")}
      </a>,
    ]);
  }
  cols.push(genCol);
  if (dataset.data_format && dataset.data_format !== " n") {
    dataset.data_set_rois.forEach(function (roi) {
      const cf = cropr.cropfields.findWhere({ did: roi.roi });
      if (cf) {
        const roiCol = [
          [gettext("Cropfield"), cf.get("name")],
          [
            gettext("Start"),
            moment(roi.recording_datetime || dataset.recording_datetime).format(" LLLL"),
          ],
        ];
        if (roi.stopped_recording_datetime) {
          roiCol.push([
            gettext("Duration"),
            moment
              .duration(moment(roi.stopped_recording_datetime).diff(moment(roi.recording_datetime)))
              .humanize(),
          ]);
        }
        roiCol.push([gettext("Overlap"), cropr.toLocaleFixed(roi.overlap_fraction * 100, 0) + "%"]);
        let recordId = processedRecords && processedRecords[cf.id];
        const record = cropr.records.findWhere({ dataset: dataset.uuid, cropfield: cf.id });
        if (!recordId && record) {
          recordId = record.id;
        }
        if (recordId) {
          roiCol.push([
            gettext("Record"),
            <a href={"/cropr/record/record/#edit/" + recordId} target="_blank">
              {gettext("Show record")}
            </a>,
          ]);
        }
        cols.push(roiCol);
      }
    });
  }
  return <DatasetDetailsContent cols={cols} />;
};

const DatasetStatistics = (props) => {
  const dataset = props.data;
  const nrFormatter = (c, r) => cropr.toLocaleFixed(c, 2);
  const columns = [
    {
      text: gettext("Measurement"),
      dataField: "measurement",
      sort: true,
      formatter: (c, r) =>
        cropr.isobus_measurement_types[r.name]
          ? cropr.isobus_measurement_types[r.name].name
          : r.name,
      headerStyle: { width: "15%" },
    },
    { text: gettext("Unit"), dataField: "unit", sort: true },
    {
      text: gettext("Machine"),
      dataField: "device",
      sort: true,
      formatter: (c, r) => cropr.getDeviceName(r.device),
      headerStyle: { width: "10%" },
    },
    { text: gettext("Min"), dataField: "min", sort: true, formatter: nrFormatter, align: "right" },
    { text: gettext("Max"), dataField: "max", sort: true, formatter: nrFormatter, align: "right" },
    {
      text: gettext("Mean"),
      dataField: "mean",
      sort: true,
      formatter: nrFormatter,
      align: "right",
    },
    { text: "Std", dataField: "std", sort: true, formatter: nrFormatter, align: "right" },
    {
      text: gettext("Count"),
      dataField: "count",
      sort: true,
      formatter: nrFormatter,
      align: "right",
    },
  ];
  [0, 4, 9, 14, 18].forEach((i) => {
    columns.push({
      text: 5 + i * 5 + "%",
      dataField: "percentiles" + i,
      sort: true,
      formatter: (c, r) => (r && r.percentiles ? cropr.toLocaleFixed(r.percentiles[i], 2) : 0),
      sortFunc: (a, b, order, dataField, rowA, rowB) => {
        a = rowA.percentiles;
        b = rowB.percentiles;
        if (!(a && b)) {
          return 0;
        }
        if (order === "asc") return a[i] - b[i];
        else return b[i] - a[i];
      },
      align: "right",
    });
  });
  if (cropr.user && cropr.user.email && cropr.user.email.endsWith("crop-r.com")) {
    columns.splice(1, 0, { text: "DDI", dataField: "name", sort: true });
  }
  return (
    <>
      <ToolkitProvider
        keyField="id"
        data={dataset.dataset_measurements}
        columns={columns}
        bootstrap4={true}
        search={{
          searchFormatted: true,
        }}
      >
        {(props) => (
          <>
            <div className="dataTables_filter">
              <SearchBar placeholder={gettext("Search")} {...props.searchProps} />
            </div>

            <BootstrapTable
              {...props.baseProps}
              pagination={paginationFactory({ bootstrap4: true })}
            />
          </>
        )}
      </ToolkitProvider>
      {dataset.data_type === "Fritzmeier" ? (
        <a href="/apps/cloudfarm/generate_fritzmeier_csv/">
          {gettext("Download cropfield comparison")}
        </a>
      ) : null}
    </>
  );
};

const DatasetDetailsContent = (props) => {
  return (
    <div className="row">
      {props.cols.map((col, j) => (
        <div className="col p-3 border-right" key={j}>
          {col.map((row, i) => (
            <div className="fieldset pb-2" key={i}>
              <label className="text-uppercase text-muted mb-0">{row[0]}</label>
              <div className={"text header" + (i === 0 ? " font-weight-bold" : "")}>{row[1]}</div>
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};

class DatasetGeometry extends React.Component {
  state = {
    geoType: "concave_hull",
    importConcaveHullEnabled: true,
    importCropfieldEnabled: true,
    importWayLinesEnabled: false,
  };

  constructor(props, context) {
    super(props, context);
  }

  componentDidMount() {
    this.setWayLines();
  }

  getIntersectingCropfields(wkt) {
    return this.getIntersectingFields(wkt, cropr.cropfields);
  }

  getIntersectingParcels(wkt) {
    return this.getIntersectingFields(wkt, cropr.parcels);
  }

  getIntersectingFields(wkt, collection) {
    const wkt_f = new OpenLayers.Format.WKT(),
      ds_geometry = wkt_f.read(wkt).geometry,
      intersecting_fields = [];

    collection.each(function (field) {
      if (!field.get("geometry")) return;
      const geometry = wkt_f.read(field.get("geometry")).geometry;
      if (
        ds_geometry.getBounds().intersectsBounds(geometry.getBounds()) &&
        ds_geometry.intersects(geometry)
      ) {
        intersecting_fields.push(field);
      }
    });
    return intersecting_fields;
  }

  setWayLines() {
    const dataset = this.props.data;
    this.newWayLines = [];
    if (!dataset.extra_info || !dataset.extra_info.partfield_lines) {
      return;
    }

    dataset.extra_info.partfield_lines.forEach((line) => {
      let geometry = line.geometry.split(";")[1],
        wayLine = new Model.WayLine({
          geometry: geometry,
          name: line.name,
          farm: cropr.farm.id,
          reference: dataset.uuid,
          manufacturer_code: this.extractManufacturerCode(),
          description: dataset.name,
          date: dataset.recording_datetime,
        });
        this.newWayLines.push(wayLine);
    });
    this.setState({ importWayLinesEnabled: this.newWayLines.length > 0 });
  }

  extractManufacturerCode() {
    const dataset = this.props.data;
    let manufacturerCode = "";
    if (dataset.extra_info && dataset.extra_info.devices) {
      Object.values(dataset.extra_info.devices).forEach((v) => {
        if (v.is_tractor) {
          manufacturerCode = v.manufacturer_code;
        }
      });
    } else if (dataset.source === "J") {
      //John Deere
      manufacturerCode = 33;
    }
    return manufacturerCode;
  }

  importGeometry = (geomType) => {
    const dataset = this.props.data;
    if (this.state.geoType === "way_lines") {
      this.newWayLines.forEach((wl) => {
        wl.save(
          {},
          {
            success: function (model, response) {
              let notificationType = 'success', msg = "Created way line %s";
              if (model.get('updated') === true){
                msg = "Updated way line %s"
              } else if (model.get('updated') === false){
                msg = "Way line %s already exists"
                notificationType = 'info'
              }
              cropr.notify(
                notificationType,
                interpolate(gettext(msg), [wl.get("name")])
              );
            },
            error: function (model, response) {
              cropr.notify(
                "danger",
                interpolate(gettext("Could not create way line %s"), [wl.get("name")])
              );
            },
          }
        );
      });
      this.setState({ importWayLinesEnabled: false });
    } else if (geomType === "parcel") {
      const ewkt =
        this.state.geoType === "concave_hull"
          ? dataset.concave_hull
          : dataset.extra_info.partfield_geometry;
      const wkt = ewkt.split(";")[1];
      const intersectingParcels = this.getIntersectingParcels(wkt);
      if (intersectingParcels.length > 1) {
        cropr.notify(
          "danger",
          interpolate(gettext("geometry intersects with parcels (%s), could not import"), [
            intersectingParcels.map((field) => field.get("name")).join(","),
          ])
        );
      } else {
        let success_message, parcel;
        if (intersectingParcels.length === 1) {
          success_message = gettext("Parcel updated");
          parcel = intersectingParcels[0];
          parcel.set({ geometry: wkt });
          let area = this.getArea(wkt);
          parcel.set({ registered_area: area });
        } else {
          success_message = gettext("Parcel created");
          parcel = new Model.Parcel({
            geometry: wkt,
            farm: cropr.farm.id,
          });
          this.setFieldName(dataset, parcel);
        }
        parcel.save(
          {},
          {
            success: function (model, response) {
              cropr.notify("success", success_message);
              if (!cropr.parcels.get(model.id)) {
                cropr.parcels.add(model);
              }
            },
          }
        );
      }
    } else {
      const ewkt =
        this.state.geoType === "concave_hull"
          ? dataset.concave_hull
          : dataset.extra_info.partfield_geometry;
      const wkt = ewkt.split(";")[1];
      const intersectingCropFields = this.getIntersectingCropfields(wkt);
      if (intersectingCropFields.length > 1) {
        cropr.notify(
          "danger",
          interpolate(gettext("geometry intersects with cropfields (%s), could not import"), [
            intersectingCropFields.map((field) => field.get("name")).join(","),
          ])
        );
      } else {
        let success_message, cropfield;
        if (intersectingCropFields.length === 1) {
          success_message = gettext("Cropfield updated");
          cropfield = intersectingCropFields[0];
          cropfield.set({ geometry: wkt });
          let area = this.getArea(wkt);
          cropfield.set({ registered_area: area, reference: "GPS" });
        } else {
          success_message = gettext("Cropfield created");
          const activePlan = cropr.getActivePlan();
          cropfield = new Model.CropField({
            geometry: wkt,
            plan: activePlan.id,
            farm: cropr.farm.id,
            period_start: activePlan.get("period_start"),
            period_end: activePlan.get("period_end"),
            reference: "GPS"
          });
          this.setFieldName(dataset, cropfield);
        }
        const that = this;
        cropfield.save(
          {},
          {
            success: function (model, response) {
              cropr.notify("success", success_message);
              if (!cropr.cropfields.get(model.id)) {
                cropr.cropfields.add(model);
              }
              that.props.handleReload(4000);
            },
          }
        );
      }
    }
  };

  setFieldName(dataset, field) {
    let cropfield_name;
    if (dataset.extra_info && dataset.extra_info.partfield_name) {
      cropfield_name = dataset.extra_info.partfield_name;
    } else {
      cropfield_name = field.generateName();
    }
    field.set({ name: cropfield_name });
  }

  getArea(wkt) {
    let wkt_f = new OpenLayers.Format.WKT();
    let field = wkt_f.read(wkt);
    let area = Cropr.getArea_m2(field) / 10000;
    return area;
  }

  render() {
    const dataset = this.props.data;
    const locations = [];
    let importEnabled = false;
    if (this.state.geoType === "concave_hull" && dataset.concave_hull) {
      locations.push({ type: "geometry", wkt: dataset.concave_hull.split(";")[1], zoomTo: true });
      importEnabled = this.state.importConcaveHullEnabled;
    }
    if (this.state.geoType === "cropfield") {
      locations.push({
        type: "geometry",
        wkt: dataset.extra_info.partfield_geometry.split(";")[1],
        zoomTo: true,
        toolTip: dataset.extra_info.partfield_name,
      });
      importEnabled = this.state.importCropfieldEnabled;
    }
    if (this.state.geoType === "way_lines") {
      dataset.extra_info.partfield_lines.forEach((line) => {
        locations.push({
          type: "geometry",
          wkt: line.geometry.split(";")[1],
          zoomTo: true,
          toolTip: line.name,
          line: true,
        });
      });
      importEnabled = this.state.importWayLinesEnabled;
    }

    return (
      <>
        <LeafletMap locations={locations} height="calc(100vh/2)" />
        <ButtonGroup className="float-left" aria-label="geometry">
          <Button
            variant={this.state.geoType === "concave_hull" ? "primary" : ""}
            onClick={(e) => this.setState({ geoType: "concave_hull" })}
          >
            {gettext("Circumference of measurements")}
          </Button>
          <Button
            variant={this.state.geoType === "cropfield" ? "primary" : ""}
            onClick={(e) => this.setState({ geoType: "cropfield" })}
            disabled={!(dataset.extra_info && dataset.extra_info.partfield_geometry)}
          >
            {gettext("Field")}
          </Button>
          <Button
            variant={this.state.geoType === "way_lines" ? "primary" : ""}
            onClick={(e) => this.setState({ geoType: "way_lines" })}
            disabled={
              !(
                dataset.extra_info &&
                dataset.extra_info.partfield_lines &&
                dataset.extra_info.partfield_lines.length > 0
              )
            }
          >
            {gettext("Way lines")}
          </Button>
        </ButtonGroup>
        <Button className="float-right m-1" disabled={!importEnabled} onClick={this.importGeometry}>
          {
            {
              concave_hull: gettext("Import as cropfield"),
              cropfield: gettext("Import as cropfield"),
              way_lines: gettext("Import way lines"),
            }[this.state.geoType]
          }
        </Button>
        {this.state.geoType === "cropfield" || this.state.geoType === "concave_hull" ? (
          <Button
            className="float-right m-1"
            disabled={!importEnabled}
            onClick={() => this.importGeometry("parcel")}
          >
            {gettext("Import as parcel")}
          </Button>
        ) : null}
      </>
    );
  }
}

const SOURCE_MAPPING = {
  U: gettext("Upload"),
  D: "Dropbox",
  A: "AGCO",
  J: "John Deere",
  I: gettext("Shared"),
  C: "CLAAS",
  DW: "Dronewerkers",
  LG: "LoonwerkGPS",
};
const DATA_FORMAT_MAPPING = {
  p: gettext("Points"),
  r: gettext("Raster"),
  g: gettext("Polygons"),
  m: gettext("Multipolygons"),
  n: "-",
  e: "-",
};
export default DatasetDetailsModal;
